import React from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

import "./OverlapChartBox.scss";
import { getAOChartData } from "src/app/project-details/tabs/AudienceOverlapTab/utils";
import { Doughnut } from "src/app/pages/CreatorDiscoveryTool/legacy/app/components/Doughnut/Doughnut";
import { ReactComponent as OverlapIcon } from "src/images/audience-overlap.svg";
import { ReactComponent as OverlapInvertedIcon } from "src/images/audience-overlap-inverted.svg";
import METHODS from "src/app/pages/CreatorDiscoveryTool/legacy/app/helpers/methods";

export const OverlapChartBox = (props) => {
  // the chart drawn with animation is still empty when a page is captured for a PDF right after rendering
  const { data, animated = true } = props;

  const { reportInfo } = data.overlapData.audienceOverlap;

  const chartData = getAOChartData(reportInfo);

  return (
    <div className="overlap-chart-box">
      <div className="overlap-chart-box__data-wrapper">
        <div className="overlap-chart-box__data">
          <span className="overlap-chart-box__data-label">
            <IDHFormattedMessage
              id="ws_total_overlapping_followers"
              defaultMessage="Total overlapping followers"
            />
          </span>
          <div className="overlap-chart-box__data-values">
            <OverlapInvertedIcon />
            <div className="overlap-chart-box__data-values-amount">
              {METHODS.splitNumbers(chartData[0]?.amount)}
            </div>
            <div className="overlap-chart-box__data-values-percent">
              {METHODS.splitPercents(chartData[0]?.percent, " ", 1)}
            </div>
          </div>
        </div>
        <div className="overlap-chart-box__data overlap-chart-box__data--unique">
          <span className="overlap-chart-box__data-label">
            <IDHFormattedMessage
              id="ws_total_unique_followers"
              defaultMessage="Total UNIQUE followers"
            />
          </span>
          <div className="overlap-chart-box__data-values">
            <OverlapIcon />
            <div className="overlap-chart-box__data-values-amount">
              {METHODS.splitNumbers(chartData[1]?.amount)}
            </div>
            <div className="overlap-chart-box__data-values-percent">
              {METHODS.splitPercents(chartData[1]?.percent, " ", 1)}
            </div>
          </div>
        </div>
      </div>
      <div>
        {reportInfo && (
          <Doughnut
            data={chartData}
            width={160}
            height={160}
            dataKey="amount"
            size={70}
            colors={["#5D78FF", "#5EC7EB"]}
            isAnimationActive={animated}
          />
        )}
      </div>
    </div>
  );
};
